<script setup>
import { computed } from 'vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import SettingsLayout from '../SettingsLayout.vue';
import SamlSettings from './components/SamlSettings.vue';
import SectionLayout from '../account/components/SectionLayout.vue';

import { usePolicy } from 'dashboard/composables/usePolicy';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
const { shouldShow } = usePolicy();

const allowedLoginMethods = computed(
  () => window.chatwootConfig.allowedLoginMethods || ['email']
);

const isSamlSsoEnabled = computed(() =>
  allowedLoginMethods.value.includes('saml')
);

const shouldShowSaml = computed(() => {
  const hasPermission = shouldShow(FEATURE_FLAGS.SAML, ['administrator']);
  return hasPermission && isSamlSsoEnabled.value;
});
</script>

<template>
  <SettingsLayout>
    <template #header>
      <BaseSettingsHeader
        :title="$t('SECURITY_SETTINGS.TITLE')"
        :description="$t('SECURITY_SETTINGS.DESCRIPTION')"
        :link-text="$t('SECURITY_SETTINGS.LINK_TEXT')"
        feature-name="saml"
      />
    </template>
    <template #body>
      <SamlSettings v-if="shouldShowSaml" />
      <SectionLayout
        v-else
        :title="$t('SECURITY_SETTINGS.SAML.TITLE')"
        :description="$t('SECURITY_SETTINGS.SAML_DISABLED_MESSAGE')"
      />
    </template>
  </SettingsLayout>
</template>
